export default "__VITE_ASSET__6pkTtKzo__"